import Markdown from 'react-markdown';
import React from 'react';

interface TextCustomizationProps {
	content: string | JSX.Element | null | undefined;
}

const TextCustomization: React.FC<TextCustomizationProps> = ({ content }) => {
	if (typeof content === 'string') {
		return <Markdown>{content}</Markdown>;
	} else {
		return <>{content}</>;
	}
};

export default TextCustomization;
